import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'
import { PRODUCT_QUERY_PARAMETER } from 'modules/product/constants'
import logUtil from 'utils/log'

export default function getSelectedVariantIdFromUrlProductUtil () {
  logUtil('getSelectedVariantIdFromUrlProductUtil').debug('start')
  return getQueryParamsFromStringObjectUtil()[PRODUCT_QUERY_PARAMETER.SELECTED_VARIANT_ID]
}
